import React from "react";
import PropTypes from "prop-types";
import decodeHTMLEntities from "core-web/utils/decodeHTMLEntities";
import AspectWrapper from "core-web/components/AspectWrapper";
import BackgroundImage from "core-web/components/BackgroundImage";
import Link from "core-web/components/Link";
import { PLACEHOLDER } from "theme/config/constants";
import styled from "theme/libs/styled";
import TextStyles from "theme/components/text/TextStyles";

const Wrapper = styled("div")`
    ${({ theme }) => theme.above.tabletLg} {
        .background {
            transition: border-radius ${({ theme }) => theme.transitions.primarySlow};
        }
        &:hover {
            .background {
                border-radius: 40px;
            }
        }
    }
    ${({ theme }) => theme.below.tabletLg} {
        .background {
            border-radius: 8px;
        }
    }
`;

const Content = styled("div")`
    display: flex;
    flex-direction: column;
    margin-top: 12px;
    gap: 6px;

    ${({ theme }) => theme.above.tabletLg} {
        gap: 8px;
    }
`;

const ArticleCard = ({ background, created, heading, category, link, loading, headingTextStyles }) => {
    const desktopImage = background?.mobile?.url;
    const mobileImage = background?.desktop?.url;

    return (
        <Wrapper>
            <Link to={link}>
                <AspectWrapper ratio={4 / 3}>
                    <BackgroundImage
                        className="background"
                        src={[
                            mobileImage || desktopImage || PLACEHOLDER,
                            null,
                            null,
                            desktopImage || mobileImage || PLACEHOLDER,
                        ]}
                        loading={loading}
                        query={{
                            w: [360, null, null, 420, 600],
                            q: 70,
                        }}
                    />
                </AspectWrapper>
                <Content>
                    {category && (
                        <TextStyles
                            textStyles={[
                                "Buenos Aires/12-120 Regular",
                                null,
                                null,
                                null,
                                "Buenos Aires/16-120 Regular",
                            ]}
                        >
                            {category}
                        </TextStyles>
                    )}
                    {heading && (
                        <TextStyles as="h2" textStyles={headingTextStyles}>
                            {decodeHTMLEntities(heading)}
                        </TextStyles>
                    )}
                    {created && (
                        <TextStyles
                            opacity="0.6"
                            mt={["6px", null, null, null, "8px"]}
                            textStyles={[
                                "Buenos Aires/12-120 Regular",
                                null,
                                null,
                                null,
                                "Buenos Aires/14-120 Regular",
                            ]}
                        >
                            {created}
                        </TextStyles>
                    )}
                </Content>
            </Link>
        </Wrapper>
    );
};

ArticleCard.propTypes = {
    background: PropTypes.shape({
        desktop: {
            url: PropTypes.string,
        },
        mobile: {
            url: PropTypes.string,
        },
    }),
    category: PropTypes.string,
    created: PropTypes.string,
    heading: PropTypes.string,
    headingTextStyles: PropTypes.object,
    link: PropTypes.string,
    loading: PropTypes.string,
};

ArticleCard.defaultProps = {
    background: {},
    category: null,
    created: null,
    heading: null,
    headingTextStyles: [
        "Buenos Aires/12-120 SemiBold",
        null,
        "Buenos Aires/16-120 SemiBold",
        null,
        "Buenos Aires/24-110 SemiBold",
    ],
    link: null,
    loading: "lazy",
};

export default ArticleCard;
